export const isUndefined = match => typeof (match) === "undefined";